import { render } from "./LabInProgress.vue?vue&type=template&id=23dc1a04&scoped=true"
import script from "./LabInProgress.vue?vue&type=script&lang=js"
export * from "./LabInProgress.vue?vue&type=script&lang=js"

import "./LabInProgress.vue?vue&type=style&index=0&id=23dc1a04&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23dc1a04"]])

export default __exports__